import { showWalletConnectModalDesk } from "../../store/slices/wallet";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { Program, AnchorProvider, setProvider, BN } from "@coral-xyz/anchor";
import { useAnchorWallet, useConnection, useWallet } from "@solana/wallet-adapter-react";
import {
  Connection,
  PublicKey,
  SystemProgram,
  Transaction,
} from "@solana/web3.js";
import { TOKEN_PROGRAM_ID, getAssociatedTokenAddressSync } from "@solana/spl-token";
import airdropIDL from "../../idl/airdropIDL.json";
import stakingIDL from "../../idl/stakingIDL.json";
import { set } from "@coral-xyz/anchor/dist/cjs/utils/features";
import Lottie from "lottie-react";
import casinoAnimation from "../../lotties/casino-chips_9090890.json";
const StakingCard = () => {
  const { connected } = useWallet();
  const wallet = useAnchorWallet();
  const [endTime, setEndTime] = useState(0);
  const [stakingProgram, setStakingProgram] = useState();
  const [airdropProgram, setAirdropProgram] = useState();
  const [anchorProvider, setAnchorProvider] = useState();
  const [stakingAmount, setStakingAmount] = useState();
  const [stakingDays, setStakingDays] = useState(109);
  const [poolId, setPoolId] = useState(1);
  const [totalStakedAmount, setTotalStakedAmount] = useState({
    "1": 0,
    "2": 0,
    "3": 0,
    "4": 0,
  });
  const [userStakedAmount, setUserStakedAmount] = useState({
    "1": 0,
    "2": 0,
    "3": 0,
    "4": 0,
  });
  // const { connection } = useConnection();
  const [estimatedReturn, setEstimatedReturn] = useState('0.00');
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const calculateTimeLeft = () => {
    const difference = endTime * 1000 - Date.now();

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000)
    };
  };

  const lockDuration = [109.5, 365, 839.5, 1460]
  const mint = new PublicKey("DmTdFpNxqzeXihLLxtkpokbVqhPqPfmeAh6L74NZofuN");
  const instructionsSysvar = new PublicKey("Sysvar1nstructions1111111111111111111111111");

  const owner = new PublicKey("FV6LFJX7YJVGR8toZ1tfzmkQbixsxRQ4KSAYHupZ3Nyr");
  const AIRDROP_STATE_SEED = "AIRDROP-STATE-SEED";
  const GLOBAL_STATE_SEED = "STAKE-STATE-SEED";

  useEffect(() => {
    if (endTime) {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      // Cleanup on component unmount
      return () => clearInterval(timer);
    }
  }, [endTime]);

  useEffect(() => {
    if (wallet) {
      const connection = new Connection('https://boldest-hidden-arm.solana-mainnet.quiknode.pro/23473190011cc724bb431c9f7ccedf2b13d489aa/');
      const provider = new AnchorProvider(connection, wallet, {});
      const authority = wallet.publicKey;
      setAnchorProvider(provider);
      const _stakingProgram = new Program(stakingIDL, {
        connection,
      })
      const _airdropProgram = new Program(airdropIDL, {
        connection,
      })
      setStakingProgram(_stakingProgram);
      setAirdropProgram(_airdropProgram);

      let newTotalStakedAmount = {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
      }

      let newUserStakedAmount = {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0
      }

      for (let i = 1; i <= 4; i++) {
        const [poolStatePda] = PublicKey.findProgramAddressSync(
          [mint.toBuffer(), Buffer.from([i])],
          _stakingProgram.programId
        );
        if (!poolStatePda) {
          console.log("Pool State PDA not found");
          return
        }
        _stakingProgram.account.poolState.fetch(poolStatePda).then((poolState) => {
          newTotalStakedAmount[i] = (poolState.amount.toString() / 10 ** 9);
          setTotalStakedAmount(newTotalStakedAmount);
        });

        const [userStatePda] = PublicKey.findProgramAddressSync(
          [poolStatePda.toBuffer(), authority.toBuffer()],
          _stakingProgram.programId
        );
        if (userStatePda) {
          _stakingProgram.account.userState.fetch(userStatePda).then((userState) => {
            newUserStakedAmount[i] = (userState.amount.toString() / 10 ** 9);
            setUserStakedAmount(newUserStakedAmount);
            if (userState.amount.toNumber() > 0) {
              setEndTime(userState.lastStakeTime.toNumber() + lockDuration[i] * 24 * 60 * 60);
            }
          }).catch(err => { });
        }
      }
    }
  }, [wallet]);

  const handleStake = async () => {
    const authority = wallet.publicKey;

    const [airdropStatePda] = PublicKey.findProgramAddressSync(
      [Buffer.from(AIRDROP_STATE_SEED)],
      airdropProgram.programId
    );

    const [globalStatePda] = PublicKey.findProgramAddressSync(
      [Buffer.from(GLOBAL_STATE_SEED)],
      stakingProgram.programId
    );

    const globalStateAccount = await stakingProgram.account.globalState.fetch(globalStatePda);

    const [poolStatePda] = PublicKey.findProgramAddressSync(
      [mint.toBuffer(), Buffer.from([poolId])],
      stakingProgram.programId
    );

    // Compute PDA for User State
    const [userStatePda] = PublicKey.findProgramAddressSync(
      [poolStatePda.toBuffer(), authority.toBuffer()],
      stakingProgram.programId
    );

    console.log("Global State PDA:", globalStatePda.toBase58());
    console.log("Pool State PDA:", poolStatePda.toBase58());
    console.log("User State PDA:", userStatePda.toBase58());

    const poolVaultATA = getAssociatedTokenAddressSync(mint, poolStatePda, true);
    console.log("poolVaultATA", poolVaultATA.toBase58());
    const userVaultATA = getAssociatedTokenAddressSync(mint, authority);

    const transaction = new Transaction();
    const connection = new Connection('https://mainnet.helius-rpc.com/?api-key=6e54f6c2-1281-4bc7-8d64-c34c92f4b4e7');

    const accountInfo = await connection.getAccountInfo(userStatePda);
    if (!accountInfo) {

      const instruction = await stakingProgram.methods
        .createUser(poolId)
        .accounts({
          authority: authority,
          owner: owner,
          globalState: globalStatePda,
          poolState: poolStatePda,
          userState: userStatePda,
          tokenProgram: TOKEN_PROGRAM_ID,
          systemProgram: SystemProgram.programId,
        })
        .instruction();
      transaction.add(instruction);

      // try {
      //   const signature = await anchorProvider.sendAndConfirm(transaction, [], {
      //     commitment: 'confirmed',
      //   });

      //   console.log('Transaction confirmed with signature:', signature);
      //   await new Promise((resolve) => setTimeout(resolve, 15000));

      // } catch (error) {
      //   console.error('transaction failed', error)

      // }

    }

    const amount = new BN(Number(stakingAmount) * Math.pow(10, 9)); // Example: 1 token (assuming 9 decimals)

    const instruction = await stakingProgram.methods
      .deposit(poolId, amount)
      .accounts({
        authority,
        owner,
        instructionsSysvar,
        globalState: globalStatePda,
        poolState: poolStatePda,
        userState: userStatePda,
        poolVault: poolVaultATA,
        userVault: userVaultATA,
        airdropState: airdropStatePda,
        airdropProgram: airdropProgram.programId,
        tokenProgram: TOKEN_PROGRAM_ID,
        systemProgram: SystemProgram.programId,
      })
      .instruction();

    transaction.add(instruction);


    try {
      const signature = await anchorProvider.sendAndConfirm(transaction, [], {
        commitment: 'confirmed',
      });

      console.log('Transaction confirmed with signature:', signature);
      await new Promise((resolve) => setTimeout(resolve, 15000));
      const userState = await stakingProgram.account.userState.fetch(userStatePda);
      setUserStakedAmount({ ...userStakedAmount, poolId: (userState.amount.toString() / 10 ** 9) });
      if (userState.amount.toNumber() > 0) {
        setEndTime(userState.lastStakeTime.toNumber() + lockDuration[poolId] * 24 * 60 * 60);
      }

      const poolState = stakingProgram.account.poolState.fetch(poolStatePda);
      setTotalStakedAmount({ ...totalStakedAmount, poolId: poolState.amount.toString() / 10 ** 9 });

    } catch (error) {
      console.error('transaction failed', error)
    }
  }
  const calculateSolValue = (amount) => {
    if (!amount || isNaN(amount)) return '0.00';
    const tokenPrice = 0.0000971; // 1 CPH = 0.0000971 SOL
    const solAmount = (parseFloat(amount) * tokenPrice).toFixed(4);
    return solAmount;
  };
  const [solValue, setSolValue] = useState('0.00');
  const [percent1, setPercent1] = useState(true);
  const [percent2, setPercent2] = useState(false);
  const [percent3, setPercent3] = useState(false);
  const [percent4, setPercent4] = useState(false);
  const dispatch = useDispatch();
  const calculateEstimatedReturn = (amount, percentageRate) => {
    if (!amount || isNaN(amount)) return '0.00';
    const principal = parseFloat(amount);
    const rate = parseFloat(percentageRate) / 100;
    const estimatedAmount = (principal + (principal * rate)).toFixed(4);
    return estimatedAmount;
  };
  const [maxBalance, setMaxBalance] = useState('0');
  const fetchTokenBalance = async () => {
    if (!wallet?.publicKey) return;

    try {
      const tokenMint = new PublicKey("DmTdFpNxqzeXihLLxtkpokbVqhPqPfmeAh6L74NZofuN");
      const userATA = getAssociatedTokenAddressSync(tokenMint, wallet.publicKey);
      const connection = new Connection('https://boldest-hidden-arm.solana-mainnet.quiknode.pro/23473190011cc724bb431c9f7ccedf2b13d489aa/');

      const balance = await connection.getTokenAccountBalance(userATA);
      const formattedBalance = (balance.value.uiAmount || 0).toString();
      setMaxBalance(formattedBalance);
    } catch (error) {
      console.error('Error fetching balance:', error);
      setMaxBalance('0');
    }
  };
  const handlePercent = (percent) => {
    console.log(percent);
    // eslint-disable-next-line default-case
    switch (percent) {
      case "30":
        setPoolId(1);
        setStakingDays(109);
        setPercent1(true);
        setPercent2(false);
        setPercent3(false);
        setPercent4(false);
        setEstimatedReturn(calculateEstimatedReturn(stakingAmount, 30));
        break;
      case "100":
        setPoolId(2);
        setStakingDays(365);
        setPercent1(false);
        setPercent2(true);
        setPercent3(false);
        setPercent4(false);
        setEstimatedReturn(calculateEstimatedReturn(stakingAmount, 100));
        break;
      case "230":
        setPoolId(3);
        setStakingDays(839);
        setPercent1(false);
        setPercent2(false);
        setPercent3(true);
        setPercent4(false);
        setEstimatedReturn(calculateEstimatedReturn(stakingAmount, 230));
        break;
      case "400":
        setPoolId(4);
        setStakingDays(1460);
        setPercent1(false);
        setPercent2(false);
        setPercent3(false);
        setPercent4(true);
        setEstimatedReturn(calculateEstimatedReturn(stakingAmount, 400));
        break;
    }
  };
  const handleMaxClick = () => {
    setStakingAmount(maxBalance);
    setSolValue(calculateSolValue(maxBalance));
    let selectedRate = percent1 ? 30 : percent2 ? 100 : percent3 ? 230 : percent4 ? 400 : 30;
    setEstimatedReturn(calculateEstimatedReturn(maxBalance, selectedRate));
  };
  useEffect(() => {
    if (connected && wallet) {
      fetchTokenBalance();
    }
  }, [connected, wallet]);
  return (
    <div className="w-full lg:w-1/2">
      <div className="flex flex-col justify-center w-full items-center gap-6 border border-[#22C8BF] py-6 border-opacity-30 rounded-md mt-14 ">
        <div className="flex flex-col justify-center items-center relative w-full">
          <p className="text-sm sm:text-xl text-[#0AF9FF]">
            AVAILABLE TO UNSTAKE IN
          </p>
          <div className="flex justify-between w-full items-center gap-2 mt-3 text-white">
            <div className="flex flex-col justify-center gap-3 bg-[#051110] w-1/4 py-3 truncate">
              <p className=" text-center sm:text-normal text-xs truncate">
                Days
              </p>
              <p className=" text-center font-medium">
                {timeLeft.days.toString().padStart(2, '0')}
              </p>
            </div>
            <div className="flex flex-col justify-center items-center gap-3 bg-[#051110] w-1/4 py-3 truncate">
              <p className=" text-center sm:text-normal text-xs truncate">
                Hours
              </p>
              <p className=" font-medium text-center">
                {timeLeft.hours.toString().padStart(2, '0')}
              </p>
            </div>
            <div className="flex flex-col justify-center items-center gap-3 bg-[#051110] w-1/4 py-3 truncate">
              <p className="text-center sm:text-normal text-xs truncate">
                Minutes
              </p>
              <p className="text-center font-medium">
                {timeLeft.minutes.toString().padStart(2, '0')}
              </p>
            </div>
            <div className="flex flex-col justify-center items-center gap-3 bg-[#051110] w-1/4 py-3 truncate">
              <p className="text-center sm:text-normal text-xs truncate">
                Seconds
              </p>
              <p className="text-center font-medium">
                {timeLeft.seconds.toString().padStart(2, '0')}
              </p>
            </div>
          </div>
        </div>
        <div className="flex w-full px-8 flex-col justify-center items-center gap-3">
          <div className="w-full flex justify-between items-center gap-6 mt-3 text-white">
            <p className=" font-semibold">{Object.values(userStakedAmount).reduce((acc, value) => acc + value, 0).toFixed(2)} $CPH</p>
            <p className=" font-semibold">{Object.values(totalStakedAmount).reduce((acc, value) => acc + value, 0).toFixed(2)} $CPH</p>
          </div>
          <div className="relative w-full">
            {/* Background line */}
            <div className="w-full h-[1px] bg-white/30">
              {/* Active progress line */}
              <div
                className="absolute left-0 top-0 h-[1px] bg-[#22C8BF]"
                style={{
                  width: `${Object.values(userStakedAmount).reduce((acc, value) => acc + value, 0) / Object.values(totalStakedAmount).reduce((acc, value) => acc + value, 0) * 100}%`
                }}
              />
              {/* Progress dot */}
              <div
                className="absolute top-1/2 -translate-y-1/2 w-[6px] h-[6px] bg-[#22C8BF] rounded-full shadow-[0_0_8px_rgba(34,200,191,0.5)]"
                style={{
                  left: `${Object.values(userStakedAmount).reduce((acc, value) => acc + value, 0) / Object.values(totalStakedAmount).reduce((acc, value) => acc + value, 0) * 100}%`
                }}
              />
            </div>
          </div>
        </div>
        <p className="text-lg text-white">
          1 $CPH = 0.0000971 SOL
        </p>
        <div className="w-full">
          <div className="w-full h-full">
            <div className="w-full flex justify-start px-8">
              <p className="text-white text-2xl text-start">Returns</p>
            </div>
            <div className="flex justify-between items-center mt-6 gap-1 sm:gap-4">
              <div
                className={`h-10 w-1/4 flex justify-center gap-2 items-center cursor-pointer 
    ${percent1 ? 'bg-[#0AF9FF]' : 'bg-[#051110]'} 
    hover:bg-opacity-70 py-1 px-6`}
                onClick={() => handlePercent('30')}
              >
                <p className={`text-xs font-medium ${percent1 ? 'text-black' : 'text-white'}`}>
                  30%
                </p>
              </div>
              <div
                className={`h-10 w-1/4 flex justify-center gap-6 items-center cursor-pointer 
    ${percent2 ? 'bg-[#0AF9FF]' : 'bg-[#051110]'} 
    hover:bg-opacity-70 py-1 px-6`}
                onClick={() => handlePercent('100')}
              >
                <p className={`text-xs font-medium ${percent2 ? 'text-black' : 'text-white'}`}>
                  100%
                </p>
              </div>
              <div
                className={`h-10 w-1/4 flex justify-center gap-6 items-center cursor-pointer 
    ${percent3 ? 'bg-[#0AF9FF]' : 'bg-[#051110]'} 
    hover:bg-opacity-70 py-1 px-6`}
                onClick={() => handlePercent('230')}
              >
                <p className={`text-xs font-medium ${percent3 ? 'text-black' : 'text-white'}`}>
                  230%
                </p>
              </div>
              <div
                className={`h-10 w-1/4 flex justify-center gap-6 items-center cursor-pointer 
    ${percent4 ? 'bg-[#0AF9FF]' : 'bg-[#051110]'} 
    hover:bg-opacity-70 py-1 px-6`}
                onClick={() => handlePercent('400')}
              >
                <p className={`text-xs font-medium ${percent4 ? 'text-black' : 'text-white'}`}>
                  400%
                </p>
              </div>
            </div>
            <div className="w-full flex justify-between mt-4 px-8">
              <p className="text-white mb-2 text-sm font-sans opacity-60">
                Looking for <span className="font-normal">{stakingDays} Days</span>
              </p>
              <p className="text-white mb-2 text-sm font-sans opacity-60">
                Estimated Return <span className="font-normal">{estimatedReturn} $CPH</span>
              </p>
            </div>
          </div>
        </div>
        <div className="flex lg:flex-row gap-10 flex-col justify-between items-center w-full h-full">
          <div className="w-full flex">
            <div className="w-full bg-[#051110] p-6">
              <div className="w-full flex justify-between">
                <p className="text-white mb-2 sm:text-normal text-sm">Stake Amount</p>
                <p
                  className="text-white relative cursor-pointer hover:opacity-70 text-sm sm:text-normal"
                  onClick={handleMaxClick}
                  style={{
                    position: 'relative',
                  }}
                >
                  Max:{maxBalance}
                  <span
                    style={{
                      display: 'block',
                      height: '1px',
                      backgroundColor: 'white',
                      position: 'absolute',
                      left: 0,
                      right: 0,
                      bottom: '7px',
                    }}
                  />
                </p>
              </div>
              <input
                onChange={(event) => {
                  const newValue = event.target.value;
                  if (/^[-+]?[0-9]*\.?[0-9]*(e[-+]?[0-9]*)?$/i.test(newValue) || newValue === "") {
                    setStakingAmount(newValue);
                    setSolValue(calculateSolValue(newValue));
                    // Get current selected percentage
                    let selectedRate = percent1 ? 30 : percent2 ? 100 : percent3 ? 230 : percent4 ? 400 : 30;
                    setEstimatedReturn(calculateEstimatedReturn(newValue, selectedRate));
                  }
                }}
                type="number"
                style={{ fontSize: '40px' }}
                className="w-full bg-transparent border-none text-white font-medium text-xl focus:outline-none focus:border-transparent"
                placeholder="0"
              />
              <p className="text-white opacity-60 mb-2">~SOL {solValue}</p>
            </div>
            <div className="flex justify-end items-center w-[200px]">
              <button
                onClick={handleStake}
                disabled={!connected}
                className={`w-full h-full flex flex-col bg-white font-medium py-1 px-3 
                  transition-all duration-300 ease-in-out transform hover:scale-[1.02]
                  truncate justify-center gap-6 items-center text-sm sm:text-normal
                  ${connected
                    ? 'text-black hover:bg-opacity-70 cursor-pointer'
                    : 'text-gray-700 cursor-not-allowed'
                  }`}
              >
                <div className="w-[50px] h-[50px] mx-auto">
                  <Lottie
                    animationData={casinoAnimation}
                    loop={true}
                    autoplay={true}
                    style={{ width: '100%', height: '100%' }}
                  />
                </div>
                <p className="text-sm sm:text-normal truncate">
                  {connected ? 'Stake' : 'Connect Wallet'}
                </p>
              </button>
            </div>
          </div>
        </div>
        <WalletMultiButton className="flex justify-between w-full items-center cursor-pointer bg-[#0AF9FF] hover:bg-opacity-70 rounded-md py-1 px-3" />
      </div>
    </div>
  )
}

export default StakingCard;